export default {
  inputRoot: {
    width: 140,
  },
};
